<template>
  <b-modal ref="demandReportModal"
           centered
           title="Eksport Zgłoszonego Popytu"
           :visible="demandExportVisible"
           @hidden="hide"
           @show="onShow">
    <fieldset  style="display: flex; flex-direction: column; gap: 10px;">
      <b-btn variant="primary" @click="exportDemand('Pdf')">Eksportuj do PDF</b-btn>
      <b-btn variant="primary" @click="exportDemand('Csv')">Eksportuj do CSV</b-btn>
      <b-btn variant="primary" @click="exportDemand('Xlsx')">Eksportuj do XLSX</b-btn>
    </fieldset>
    <div slot="modal-footer">
      <b-btn variant="outline-secondary" @click="hide">Anuluj</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import {WINDOW_DEMAND_EXPORT_HIDE} from "../store/mutations.type";

export default {
  name: "demandExportWindow",
  data: function() {
    return {

    };
  },
  computed: {
    ...mapGetters(["demandExportVisible"]),
  },
  methods: {
    exportDemand(target) {
      this.hide()
      this.$emit('export-demand', target);
    },
    hide() {
      this.$store.commit(WINDOW_DEMAND_EXPORT_HIDE);
    },
    onShow() {
    }
  },
};
</script>
